import ReactDOM from 'react-dom'
import './styles.css'
import App from './App'
import InfoBox from './Info'

ReactDOM.render(
  <>
    <App />
  </>,
  document.getElementById('root'),
)
